import { PageHeader } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { EMPTY_ELEMENT_OVERRIDE_MARKUP } from 'domains/markupDomain';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ElementOverrideItemForm from './ElementOverrideItemForm';
import ElementOverrideTable from './ElementOverrideTable';

const ElementOverrideTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const curItem = useAppSelector(
    (state) => state.markup.curElementOverrideMarkup
  );

  return (
    <>
      <PageHeader
        ghost={false}
        extra={[
          <RevxButton
            key="create"
            type="primary"
            onClick={() => {
              dispatch.markup.setState({
                curElementOverrideMarkup: EMPTY_ELEMENT_OVERRIDE_MARKUP,
              });
            }}
          >
            {t('platform.markup.titles.create')}
          </RevxButton>,
        ]}
      />

      {curItem && <ElementOverrideItemForm />}
      <ElementOverrideTable />
    </>
  );
};

export default ElementOverrideTab;
